"use client";
import { useEffect, useState } from "react";
import { navItems } from "@/src/constants/nav-items";

import { MobileMenuProps } from "./types";
import AnimatedMobileMenuItem from "@/src/components/AnimatedMobileMenuItem";

export function MobileMenu({
  isOpen,
  toggleMenu,
  openContactModal,
  onNavItemClick,
}: MobileMenuProps) {
  const [animationOrder, setAnimationOrder] = useState<number[]>([]);

  useEffect(() => {
    if (isOpen) {
      const order = Array.from({ length: navItems.length + 1 }, (_, i) => i);
      setAnimationOrder(order);
    } else {
      setAnimationOrder([]);
    }
  }, [isOpen]);

  return (
    <div
      className={`fixed top-0 left-0 w-full h-full bg-[#E5E5E5] flex flex-col items-center justify-center z-10 
      transform transition-transform duration-300 ease-out
      ${isOpen ? "translate-y-0" : "-translate-y-full"}`}
    >
      <ul className="flex flex-col space-y-6 text-blue-500 text-2xl">
        {navItems.map((item, index) => (
          <AnimatedMobileMenuItem
            key={item.name}
            name={item.path}
            delay={animationOrder[index] * 100}
            onClick={() => {
              onNavItemClick(item.path);
              toggleMenu();
            }}
          />
        ))}

        <AnimatedMobileMenuItem
          name="Contact"
          delay={animationOrder[navItems.length] * 100}
          onClick={() => {
            openContactModal();
            toggleMenu();
          }}
        />
      </ul>
    </div>
  );
}
